require('./home');

$(function() {
    $(window).scroll(function(){
        var maTarget = $('.nos-prestations');
        if (maTarget.length) {
            if ($(window).scrollTop() >= ($('.nos-prestations').offset().top-$('.navigation-product').height())) {
                $('.navigation-product').addClass('sticky');
            }
            else {
                $('.navigation-product').removeClass('sticky');
            }
        }

        var maTarget = $('.navigation-product-item');
        if (maTarget.length) {
            $('.navigation-product-item').each(function () {
                var id = $(this).attr('id');
                if (window.matchMedia("(max-width: 767px)").matches && (id === "experience" || id === "informations-pratiques")) {
                    $(this).addClass('active');
                }
                if ($(window).scrollTop() >= ($(this).offset().top)) {
                    $('.navigation-product-left li').removeClass('active');
                    $(".navigation-product-left li a[href='#" + id + "']").closest('li').addClass('active');
                }
            });
        }

        var maTarget = $(".tab-bar");
        if (window.matchMedia("(max-width: 767px)").matches && maTarget.length > 0) {
            if ($(window).scrollTop() >= $("#map").offset().top) {
                maTarget.hide();
            } else {
                maTarget.show();
            }
        }
    });

    $eve = $('#evenements-pros .grid').masonry({
        itemSelector: '.grid-item',
        gutter: 10,
        columnWidth: '.grid-sizer',
        isFitWidth: true
    });

    $eve.imagesLoaded().progress( function() {
        $eve.masonry('layout');
    });

    $('.section-heading').click(function() {
        var $section = $(this).closest('section');
        $section.toggleClass('active');
        $eve.imagesLoaded().progress( function() {
            $eve.masonry('layout');
        });
    });

    $('.slick-slider-top').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        var i = (nextSlide ? nextSlide : 0) + 1;
        $('.slider-image-container .slider-index').text(i);
        $('.slider-image-container .slider-count').text(slick.slideCount);
        $('.slider-image-container .slider-arrow').addClass('active');
    });

    $('.slick-slider-top').slick({
        appendArrows: $('.slider-image-container .slider-arrow'),
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"></svg><span class="sr-only">Visuel précédent</span></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"></svg><span class="sr-only">Visuel suivant</span></button>',
    });

    $('.list-prestations li a').click(function(){
        var index = $(this).closest('li').index();
        $('.list-prestations >li').removeClass('active');
        $('.nos-prestations-infos >li').removeClass('active');
        $(this).closest('li').addClass('active');
        $('.nos-prestations-infos >li:eq('+index+')').addClass('active');
        var value = $('.nos-prestations select').children('option:eq('+index+')').val();
        $('.nos-prestations select').val(value);

        $element_click = $(this).data('type');
        $href = $('.product_reservation_btn').attr('href');

        $href = $href.replace("DEC", $element_click);
        $href = $href.replace("ETOI", $element_click);
        $href = $href.replace("PREM", $element_click);

        $('.product_reservation_btn').attr('href',$href);

        return false;
    })

    $('.nos-prestations select').change(function(){
        var index = $(this).children('option:selected').index();
        $('.list-prestations >li').removeClass('active');
        $('.nos-prestations-infos >li').removeClass('active');
        $('.list-prestations >li:eq('+index+')').addClass('active');
        $('.nos-prestations-infos >li:eq('+index+')').addClass('active');
        return false;
    });

    $('#menupopup-2, #menupopup-3, #menupopup-4, #menupopup-5').popup({
        closebutton: true,
        escape: true,
        closebuttonmarkup: '<a href="#" class="menupopup_close"><div class="icon icon-cross"><span class="sr-only">Fermer</span></div></a>'
    });

    $('#drinkpopup-2, #drinkpopup-3, #drinkpopup-4, #drinkpopup-5').popup({
        closebutton: true,
        escape: true,
        closebuttonmarkup: '<a href="#" class="drinkpopup_close"><div class="icon icon-cross"><span class="sr-only">Fermer</span></div></a>'
    });

    $('body').on('click', '.list-prestations-elem a', function (e) {



    });

});